import { useParams } from "react-router";
import { useLatestFinancialHighlights } from "../DetailPage/FinancialComponents/ratios";

export const addCommasToNumber = (number) => {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const  useCard = (data) => {
    // 1. Calculate Total Funding
    const deals = data.private_equity?.pe_investments || [];

    const totalFunding =
        deals.length > 1
            ? deals.reduce((sum, d) => sum + Number(d.amount || 0), 0)
            : deals.reduce((sum, d) => (!d.is_amount_hide ? sum + Number(d.amount || 0) : sum), 0);

   // 2. Find Latest Round
    const latestRoundDate = [
        ...data?.private_equity?.pe_investments?.map(investment => new Date(investment.deal_date)) || [],
        ...data?.private_equity?.angel_investments?.map(investment => new Date(investment.date)) || [],
        ...data?.private_equity?.incubation_investments?.map(investment => new Date(investment.date)) || []
    ].reduce((latestDate, currentDate) => {
        return currentDate > latestDate ? currentDate : latestDate;
    }, null); // Use null as the initial value

    // Format date to MMM-YYYY
    const latestRound = latestRoundDate?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });

    // 3. Calculate Total Exits
    const totalExits = data?.private_equity?.pe_exits?.reduce((total, exit) => total + parseFloat(exit.amount), 0).toFixed(2);

    // 4. Count Number of Investors
    const investorsSet = new Set();
    data?.private_equity?.pe_investments?.forEach(investment => {
    investment.investors.forEach(investor => {
        if(investor.id !== 9){
            investorsSet.add(investor.id);
        }
    });
    });

    const numberOfInvestors = investorsSet.size;

    // 5. To get the latest revenue
    const latest = useLatestFinancialHighlights(data)

    // 6. Count the acquirer and acquistions
    const acquirerSet = new Set();
    const acquisitionSet = new Set();
    const {companyId} = useParams();
    const cmpId = parseInt(companyId);

    data?.merger_acquisition?.forEach(item => {
        if (cmpId !== item.company.id) {
            acquisitionSet.add(item.company.id);
        } else acquirerSet.add(item.acquirer.name);
        
    });

    const numberOfAcquirers = acquirerSet.size;
    const numberOfAcquisitions = acquisitionSet.size;

    // Sort transactions by date in descending order
    const sortedTransactions = data?.merger_acquisition?.length != 0 ? data?.merger_acquisition?.sort((a, b) => new Date(b.date) - new Date(a.date)) : [];

    // Find the first transaction with a non-zero company valuation
    const validTransaction = sortedTransactions?.find(
        transaction => parseFloat(transaction?.company_valuation) > 0
    );

    const companyValuation = validTransaction ? parseInt(validTransaction?.company_valuation).toFixed(0) : null;

    console.log(companyValuation, "companyValuation", validTransaction)

    // New object with calculated values
    const calculatedValues = {
        totalFunding: totalFunding?.toFixed(2),
        latest_round: latestRound,
        totalExits,
        no_of_investors: numberOfInvestors,
        revenue: latest.total_income,
        fy:latest.fy,
        numberOfAcquirers,
        numberOfAcquisitions,
        enterprise_value : companyValuation !== null ? addCommasToNumber(companyValuation) : 0
    };

    return calculatedValues;
}